import React, { FC } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import type { AutocompleteProps } from "@mui/material/Autocomplete";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

import SVG from "@/assets/svg";
import { LabeledInput } from "@/component/input";
import { IInput } from "./labeledInput";

export interface IAutoComplete extends Omit<
  AutocompleteProps<any, boolean, boolean, boolean>,
  "renderInput"
> {
  onSelectItem: (event: any, newValue: any | null) => void;
  renderInput?: (params: any) => React.ReactNode;
  inputProps?: IInput;
  id?: string;
}

const AutoCompleteComponent: FC<IAutoComplete> = ({
  multiple,
  value,
  onSelectItem,
  options,
  renderInput,
  getOptionLabel,
  inputProps,
  noOptionsText = "No Options",
  id,
  disabled,
  ...rest
}) => {
  const [open, setOpen] = React.useState(false);
  const normalizedValue = multiple
    ? value
    : Array.isArray(value)
      ? (value[0] ?? null)
      : (value ?? null);
  const inputName =
    inputProps?.placeholder ||
    (typeof inputProps?.label === "string" ? inputProps.label : "filter");
  const popupControlLabel = `${open ? "Close" : "Open"} ${inputName} options`;

  return (
    <Autocomplete
      autoComplete={false}
      disabled={disabled}
      open={open && !disabled}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      multiple={multiple}
      noOptionsText={noOptionsText}
      disableCloseOnSelect={multiple}
      value={normalizedValue}
      onChange={onSelectItem}
      options={options}
      clearIcon={null}
      getOptionLabel={getOptionLabel}
      renderInput={(params) => (
        <FormGroup sx={{ position: "relative" }}>
          <LabeledInput
            type="autocomplete"
            {...params}
            {...inputProps}
            {...(!multiple && {
              setOpen,
            })}
            id={id}
            slotProps={{
              ...params.slotProps,
              ...inputProps?.slotProps,
              input: {
                ...params.slotProps.input,
                ...(typeof inputProps?.slotProps?.input === "object"
                  ? inputProps.slotProps.input
                  : {}),
                endAdornment: (
                  // <InputAdornment position="end" sx={{ position: "absolute", top: 12, right: 8 }}>
                  //   <IconButton size="small">
                  //     {/* <SearchIcon /> */}
                  //     <SVG.Search></SVG.Search>
                  //   </IconButton>
                  // </InputAdornment>

                  <InputAdornment
                    position="end"
                    sx={{ position: "absolute", right: 8 }}
                  >
                    <IconButton
                      aria-label={popupControlLabel}
                      title={popupControlLabel}
                      size="small"
                      edge="end"
                      disabled={disabled}
                      onClick={() => setOpen((current) => !current)}
                    >
                      <SVG.Search />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </FormGroup>
      )}
      forcePopupIcon={false}
      {...rest}
    />
  );
};

export default AutoCompleteComponent;
